import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ButtonGroupLayout, LayoutGap } from '@gov-nx/ui/web';
import { GridSkeleton } from '../../Skeleton/GridSkeleton';

export const SupportSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<LayoutGap gap="m">
			<LayoutGap
				gap="m"
				className="bg-(--background-block-primary) p-4">
				<LayoutGap>
					<div className="flex gap-4 items-center">
						<GovSkeleton
							width="40px"
							height="40px"
							className="py-2"
							shape="circle"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
						<GovSkeleton
							width="150px"
							height="28px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
					</div>
					<LayoutGap className="ml-14!">
						<GovSkeleton
							width="70%"
							height="22px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
						/>
						<GridSkeleton rows={2} />
						<div>
							<div>
								<GovSkeleton
									width="50px"
									height="22px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
								/>
							</div>
							<div>
								<GovSkeleton
									width="275px"
									height="40px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
								/>
							</div>
						</div>
						<div>
							<div>
								<GovSkeleton
									width="50px"
									height="22px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
								/>
							</div>
							<div>
								<GovSkeleton
									width="275px"
									height="40px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
								/>
							</div>
						</div>
						<ButtonGroupLayout>
							<GovSkeleton
								width="170px"
								height="50px"
								aria-label={t('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
							/>
						</ButtonGroupLayout>
					</LayoutGap>
				</LayoutGap>
			</LayoutGap>
			<LayoutGap
				gap="m"
				className="bg-(--background-block-primary) p-4">
				<div className="flex gap-4 items-center">
					<GovSkeleton
						width="40px"
						height="40px"
						className="py-2"
						shape="circle"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="120px"
						height="28px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
			</LayoutGap>
			<LayoutGap
				gap="m"
				className="bg-(--background-block-primary) p-4">
				<div className="flex gap-4 items-center">
					<GovSkeleton
						width="40px"
						height="40px"
						className="py-2"
						shape="circle"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						width="100px"
						height="28px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
			</LayoutGap>
		</LayoutGap>
	);
};
